import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { await login(email, password); } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between p-12 bg-[#064E3B] text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center opacity-25" style={{ backgroundImage: "url(https://images.unsplash.com/photo-1470075801209-17f9ec0cada6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600)" }} />
        <div className="relative"><span className="font-heading text-2xl font-bold">Contologico</span></div>
        <div className="relative max-w-md">
          <h2 className="font-heading text-3xl font-semibold leading-tight">Valutare, finanziare e consuntivare ogni operazione immobiliare.</h2>
          <p className="mt-4 text-emerald-100/90 text-sm">Preventivo, SAL e Finale sempre distinti. Ogni totale riconciliabile con il dettaglio.</p>
        </div>
        <div className="relative" />
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5 bg-white border rounded-md p-8 shadow-sm" data-testid="login-form">
          <div>
            <h1 className="font-heading text-2xl font-semibold">Accedi</h1>
            <p className="text-sm text-slate-500 mt-1">Inserisci le credenziali aziendali</p>
          </div>
          <label className="block text-sm">
            <span className="text-slate-600 font-medium">Email</span>
            <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="input-editable mt-1" autoComplete="username" />
          </label>
          <label className="block text-sm">
            <span className="text-slate-600 font-medium">Password</span>
            <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="input-editable mt-1" autoComplete="current-password" />
          </label>
          {error && <div className="text-sm text-red-800 bg-red-50 border border-red-200 rounded p-2" data-testid="login-error">{error}</div>}
          <Button type="submit" className="w-full" disabled={busy} data-testid="login-submit">{busy ? "Accesso…" : "Entra"}</Button>
        </form>
      </div>
    </div>
  );
}
